    <ng-container *ngIf="controlTemplate?.settings?.value?.refueled !== undefined && controlTemplate?.settings?.value?.refueled !== null; else noValue">
        {{ controlTemplate?.settings?.value?.refueled }}<span *ngIf="controlTemplate?.settings?.suffix"> {{controlTemplate?.settings?.suffix}}</span>
    </ng-container>
    <ng-template #noValue>
        -
    </ng-template>